import { Component, Input } from '@angular/core';
import { Agent } from '../../../domain/interfaces/agents';
import { NgClass, TitleCasePipe } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TimePeriodPipe } from '../../../core/pipes/time-period.pipe';

@Component({
  selector: 'app-agent-card',
  templateUrl: './agent-card.component.html',
  styleUrls: ['./agent-card.component.scss'],
  imports: [NgClass, IonicModule, TimePeriodPipe, TitleCasePipe],
})
export class AgentCardComponent {
  @Input() agent: Agent;

  calcIcon() {
    const status = this.agent.CurrentEvent.Status.Item.Icon;
    return `assets/icon/${status}.svg`;
  }
}
